<template>
  <v-dialog
    :model-value="modelValue"
    fullscreen
    scrollable
    transition="dialog-bottom-transition"
    @update:model-value="emitUpdate"
  >
    <v-card class="dialog">
      <v-card-title class="d-flex">
        <v-btn
          class="ms-n4 me-1"
          icon
          variant="text"
          @click="closeModal"
        >
          <icon height="14" width="14">close-x</icon>
        </v-btn>
        <h4 class="flex-grow-1">Need Help?</h4>
      </v-card-title>
      <v-card-text class="pt-5" style="height: calc(100vh - 64px);">
        <v-form lazy-validation @submit.prevent="submitForm">
          <h5 class="font-weight-bold mb-4">
            What are you having issues with?
          </h5>
          <v-select
            v-model="itemSelected"
            class="mt-4 mb-n3"
            density="compact"
            :items="options"
            label="Select option"
            variant="outlined"
            persistent-hint
          ></v-select>
          <h5 class="font-weight-bold mb-4">
            Please tell us how we can help:
          </h5>
          <v-textarea
            v-model="question"
            class="mb-0 rounded-xl"
            label="Enter your request here"
            name="input-7-4"
            variant="outlined"
          ></v-textarea>

          <v-btn
            class="font-weight-bold white--text text-decoration-none rounded-pill"
            color="primary"
            :disabled="!question || !itemSelected || loading"
            size="large"
            :loading="loading"
            type="submit"
            variant="flat"
            width="100%"
          >
            Submit
          </v-btn>
        </v-form>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters, mapState } from 'vuex';

export default {
  props: {
    modelValue: {
      type: Boolean,
      default: false
    }
  },
  emits: ['update:modelValue', 'close-modal', 'confirmation-modal'],
  data() {
    return {
      loading: false,
      question: '',
      itemSelected: null
    };
  },
  computed: {
    ...mapState(['offer', 'partner', 'partnerUser']),
    ...mapGetters('deals', { getDeals: 'list' }),
    deals() {
      return this.getDeals || [];
    },
    options() {
      const dealNames = this.deals.map(deal => deal.name);
      return ['My Account', ...dealNames, 'Other'];
    }
  },
  methods: {
    emitUpdate(value) {
      this.$emit('update:modelValue', value);
    },
    closeModal() {
      this.$emit('update:modelValue', false);
      this.$emit('close-modal');
    },
    resetForm() {
      this.loading = false;
      this.question = '';
      this.itemSelected = null;
    },
    getSelectedOrderId() {
      const lastDeal = this.deals[this.deals.length - 1];
      const lastOrderDeals = lastDeal?.order_deals || [];

      if (this.itemSelected) {
        const dealSelected = this.deals.filter(
          deal => this.itemSelected === deal.name
        );

        if (dealSelected.length > 0) {
          const selectedOrders = dealSelected[0].order_deals || [];
          return selectedOrders[selectedOrders.length - 1]?.order_id;
        }

        return lastOrderDeals[lastOrderDeals.length - 1]?.order_id;
      }

      return null;
    },
    async submitForm() {
      this.loading = true;
      if (this.partnerUser) {
        this.partnerUser.contact_permission = 1;
      }

      const orderId = this.getSelectedOrderId();

      await this.$api.misc.submitHelpForm({
        question: this.question,
        itemSelected: this.itemSelected,
        partnerName: this.partner?.name,
        partnerId: this.partner?.id,
        partnerUserId: this.partnerUser?.id,
        orderId
      });

      this.$emit('confirmation-modal', true);
      this.closeModal();
      this.resetForm();
    }
  }
};
</script>

<style lang="scss" scoped>
.success-modal {
  border-radius: 1rem;
}

:deep(.v-dialog--fullscreen) {
  box-shadow: none !important;
}

.v-radio {
  &:deep(.v-input--selection-controls__input) {
    height: 20px;
    width: 20px;
    border-radius: 50%;
    border: solid 2px var(--v-primary-base);
    margin-right: 10px;

    & .v-input--selection-controls__ripple {
      left: -1rem;
    }
  }

  &.v-item--active {
    &:deep(.v-input--selection-controls__input) {
      background: var(--v-primary-base);
      box-shadow: 0 0 0 3px #ffffff inset;
    }
  }
}
</style>
